import {Component} from '@angular/core';
import {IYii} from '../../../globals';
import {FormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {FormService} from '../services/FormService';
import {Checkbox} from 'primeng/checkbox';
import {Textarea} from 'primeng/textarea';

declare var Yii: IYii;

@Component({
  selector: 'ng-form-general',
  template: `
    <div class="form-row flex-align-center">
      <label>
        {{ Yii.t('app', 'Form Name') }}
        <span class="text-danger">*</span>
      </label>
      <div>
        <input
          type="text"
          id="form-builder-form-name"
          name="form-name"
          style="width: 100%"
          pInputText
          [(ngModel)]="fsvc.form_json.form_name">
      </div>
    </div>
    @if (fsvc.form_json.form_id > 1) {
      <div class="form-row">
        <label>
          {{ Yii.t('app', 'Form Template') }}
        </label>
        <div>
          {{ fsvc.form_json.form_id }}
        </div>
      </div>
    }

    <div class="form-row">
      <label>
        {{ Yii.t('app', 'Additional Title (long title)') }}
      </label>
      <div>
        <textarea
          rows="3"
          pTextarea
          style="width: 100%"
          [autoResize]="true"
          [(ngModel)]="fsvc.form_json.additional_title"></textarea>
      </div>
    </div>
    @if (fsvc.form_json.type == 1) {
      <div class="form-row">
        <label>
          {{ Yii.t('app', 'Lock with NFC') }}
        </label>
        <div>
          <p-checkbox [(ngModel)]="fsvc.form_json.nfc_lock" binary="true"></p-checkbox>
        </div>
      </div>
    }
  `,
  imports: [
    FormsModule,
    InputText,
    Checkbox,
    Textarea
  ]
})
export class FormGeneral {
  Yii = Yii

  constructor(public fsvc: FormService) {
  }
}
